<template>
    <transition name="calendar-mask">
        <div v-show="show" @click.stop="$emit('change',false)" class="calendar">
            <transition name="calendar">
                <div @click.stop v-show="show" class="calendar-body" :style="{height:height}">
                    <div class="calendar-title">
                        <span>{{ title }}</span>
                        <i @click.stop="$emit('change',false)" class="iconfont icon-guanbi"></i>
                    </div>
                    <div class="calendar-content">
                        <div class="week-title">
                            <div class="week-title-item" v-for="(item,index) in weekTitle" :key="index">{{ item }}</div>
                        </div>
                        <div class="month">
                            <div class="month-item" v-for="(item,index) in calendar" :key="index">
                                <div class="month-item-title">{{ item.year + '-' + item.month}}</div>
                                <div class="month-item-body">
                                    <div class="week" v-for="(val,key) in item.week" :key="key">
                                        <div @click.stop="select(item.year,item.month,day)" class="week-item" v-for="(day,didx) in val" :key="didx">
                                            <div v-if="day.d" :class="{disable:!day.isclick,'day-active':checked == `${item.year}-${item.month}-${day.d < 10?'0' + day.d:day.d}`}" class="week-item-content">
                                                <div class="date-info">{{ day.d }}</div>
                                                <div v-if="day.isclick" class="mark-info">{{day.mark}}</div>
                                            </div>
                                            <div v-else class="week-item-content">
                                                <div class="date-info"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>
<script>
export default {
    data(){
        return {
            calendar:[]
        }
    },
    props:{
        show:{
            type:Boolean,
            default:true
        },
        title:{
            type:String,
            default:'请选择日期'
        },
        height:{
            type:String,
            default:'500px'
        },
        weekTitle:{
            type:[Array,Object],
            default:function(){
                return['日','一','二','三','四','五','六']
            }
        },
        checked:{
            type:String,
            default:''
        },
        mark:{
            type:[Object,String],
            default:function(){
                return {}
            }
        },
        dateType:{
            type:String,
            default:'default'
        },
        cusCalendar:{
            type:Object,
            default:function(){
                return {}
            }
        },
        dateSlot:{
            type:Object,
            default:function(){
                return {start:'2020-01-01',end:'2020-01-31'}
            }
        }
    },
    model:{
        prop:'show',
        event:'change'
    },
    watch:{
        show(val){
            if(val){
                this.initCalendar();
            }
        },
        checked(val){
            console.log(val)
        }
    },
    created(){
    },
    methods:{
        initCalendar(){
            let calendar = [];
            let s = this.dateSlot.start.split('-'),e = this.dateSlot.end.split('-');
            let monthCount = (parseInt(e[0]) - parseInt(s[0])) * 12 + (parseInt(e[1]) - parseInt(s[1])) + 1;
            let y = parseInt(s[0]),m = parseInt(s[1]);
            for(let i = 0;i<monthCount;i++){
                let key = `${y}-${m<10?'0'+m:m}`
                // 本月最后一天
                let lastday = new Date(y,m,0).getDate();
                // 获取起始周的第一天
                let startweek = new Date(y,m-1,1).getDay();
                let weeknum = Math.ceil((startweek + lastday + 1) / 7);
                let d = 1;
                let week = [];
                //循环周数
                for(let j = 1;j<=weeknum;j++){
                    let weekarr = [];
                    //循环添加周数的天数
                    for(let k = 0;k < 7;k++){
                        if(j == 1 && k < startweek){
                            weekarr.push('')
                        }else if(d > lastday){
                            weekarr.push('');
                        }else{
                            let full_day = `${y}${m<10?'0'+m:m}${d<10?'0'+d:d}`; //自行修改时间，现为 yyyyMMdd
                            weekarr.push({
                                d,
                                mark:this.cusCalendar[full_day]?isNaN(parseFloat(this.mark))?this.mark:parseFloat(this.mark):'', //自行修改标记 内容
                                isclick:this.dateType == 'custom'?(this.cusCalendar[full_day]?true:false):true
                            })
                            d ++;
                        }
                    }
                    week.push(weekarr);
                }
                calendar.push({year:y.toString(),month:m < 10?'0' + m:m,week:week})
                if(m == 12){
                    y += 1;
                    m = 1;
                }else{
                    m += 1;
                }
            }
            this.calendar = calendar;
        },
        select(y,m,d){
            if(!d.isclick){
                return;
            }
            this.$emit('change',false)
            this.$emit('select',`${y}-${m}-${d.d < 10?'0'+d.d:d.d}`)
        }
    }
}
</script>
<style>
.calendar{
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:233;
    background:rgba(0,0,0,.3);
    font-size:14px;
}
.calendar-body{
    background:#fff;
    position: absolute;
    width:100%;
    bottom:0;
    display: flex;
    flex-direction:column;
}
.calendar-title{
    padding:10px 16px;
    text-align:center;
    flex-shrink:0;
    position:relative;
}
.calendar-title .iconfont{
    font-size:14px;
    position: absolute;
    top:50%;
    transform:translateY(-50%);
    right:16px;
}
.calendar-content{
    display:flex;
    height:100%;
    flex-direction:column;
    overflow:hidden;
}
.week-title{
    display: flex;
    flex-shrink:0;
    border-bottom:1px solid #f7f8fa;
}
.week-title-item{
    flex:1 0 auto;
    text-align:center;
    padding:10px 0;
    font-weight:400;
}
.month{
    height:100%;
    overflow-y:auto;
}
.month-item-title{
    background:#f7f8fa;
    text-align:center;
    padding:10px 0;
}
.week{
    display:flex;
}
.week-item{
    flex:1 0 auto;
    text-align:center;
}
.week-item-content{
    text-align:center;
    height:60px;
    position: relative;
    vertical-align:middle;
}

.date-info{
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
}
.mark-info{
    position:absolute;
    top:80%;
    left:10%;
    right:10%;
    transform: translate(0,-50%);
    font-size:12px;
    text-align:center;
    color:#f3b334;
}
.calendar-enter-active, .calendar-leave-active,.calendar-mask-enter-active, .calendar-mask-leave-active{
    transition:all .3s;
}
.calendar-enter,.calendar-leave-to{
    transform: translateY(100%);
}
.calendar-mask-enter,.calendar-mask-leave-to{
    opacity:0;
}
.disable{
    color:#cccccc !important;
}
.disable .mark-info{
    color:#cccccc !important;
}
.day-active{
    background:#0087ff;
    color:#fff;
}
</style>